import React, {useEffect, useState} from "react";
import {AddDebtsFormFields, AddUpdateDebtsModalComponentProps, UpdateDebtFormFields} from "../../../models/debts/debt";
import {Button, Form, Input, Modal, notification, Select} from "antd";
import {FieldData} from "../../../models/filter-table/filter-table";
import {FormProps} from "antd/lib/form/Form";
import debtsService from "../../../services/debts-service";
import TextArea from "antd/lib/input/TextArea";
const { Option } = Select;

export const AddUpdateDebtModal = (props: AddUpdateDebtsModalComponentProps) => {

    const [form] = Form.useForm();
    const [api, contextHolder] = notification.useNotification();
    const debtType = Form.useWatch('systemType', form);
    const [formData, setFormData] = useState<FieldData[]>([
        {name: ["id"], value: props.debt.id},
        {name: ["propertyId"], value: props.debt.propertyId},
        {name: ["systemType"], value: props.debt.systemType},
        {name: ["type"], value: props.debt.type},
        {name: ["sum"], value: props.debt.sum},
        {name: ["comment"], value: props.debt.comment},
        {name: ["lastPaidMeterData"], value: props.debt.lastPaidMeterData},
        {name: ["connectionId"], value: props.debt.connectionId},
        {name: ["electricityKwhRate"], value: props.debt.electricityKwhRate},
    ]);

    useEffect(() => {
        setFormData([
            {name: ["id"], value: props.debt.id},
            {name: ["propertyId"], value: props.debt.propertyId},
            {name: ["systemType"], value: props.debt.systemType},
            {name: ["type"], value: props.debt.type},
            {name: ["sum"], value: props.debt.sum},
            {name: ["comment"], value: props.debt.comment},
            {name: ["lastPaidMeterData"], value: props.debt.lastPaidMeterData},
            {name: ["connectionId"], value: props.debt.connectionId},
            {name: ["electricityKwhRate"], value: props.debt.electricityKwhRate},
        ])
    }, [props])

    const handleCancel = () => {
        props.close();
    }

    const onSubmitHandler = async () => {
        console.log(form.getFieldsValue());

        const [status, title, messages] = (props.type === "add"
            ? await debtsService.add(form.getFieldsValue() as UpdateDebtFormFields)
            : await debtsService.update(form.getFieldsValue() as UpdateDebtFormFields)
        )

        if (!status) {
            api.error({
                message: title,
                description: <>{messages.map((val, index) => {
                    return (<span key={index}>{val}</span>)
                })}</>,
                showProgress: true,
                pauseOnHover: true,
                duration: 10,
            });
        } else {
            props.close();
            props.recallData()
        }
    };


    const onSubmitFail = () => {
        console.log(form.getFieldsValue())
    }

    const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    };

    const onConnectionIdSelectHandler = (connectionId: number) => {

        if (props.connections !== null && props.connections !== undefined) {
            const found = props.connections.find((c) => c.id === connectionId);
            console.log(found);
            form.setFieldsValue({
                type: "(Elekter) " + found?.connectionName,
            });
        }
    }

    return(
        <>
            {contextHolder}
            <Modal
            open={props.openCloseState}
            title="Изменение данных долга"
            onCancel={props.close}
            footer={[]}
            >
                <Form
                    form={form}
                    fields={formData}
                    name="editDebtModal"
                    autoComplete="off"
                    layout="vertical"
                    onFinish={onSubmitHandler}
                    onFinishFailed={onFinishFailed}
                    style={{ width: "100%" }}
                >
                    <Form.Item name="id" hidden={true}>
                        <Input type={"number"}/>
                    </Form.Item>
                    <Form.Item name="systemType" label="Выберите общий тип долга" rules={[{ required: true }]}>
                        <Select>
                            <Option value={"membershipFee"}>Членский взнос</Option>
                            <Option value={"electricity"}>Элекстричество</Option>
                            <Option value={"waterKey"}>Ключь от скважены</Option>
                            <Option value={"other"}>Другое</Option>
                        </Select>
                    </Form.Item>
                    {props.connections !== null
                        ? <Form.Item name="connectionId" label="Выберите связанное подключение" hidden={(debtType === "electricity" ? false : true)}>
                            <Select onChange={(value) => onConnectionIdSelectHandler(parseInt(value))}>
                                {props.connections.map((connection, index) =>
                                        <Option value={connection.id}>{connection.connectionName}</Option>
                                    )
                                }
                            </Select>
                        </Form.Item>
                        : <></>
                    }
                    <Form.Item name="type" label="Полное название">
                        <Input placeholder="" type={"text"} disabled={(debtType === "electricity" ? true : false)}/>
                    </Form.Item>
                    <Form.Item name="electricityKwhRate" label="Тариф на электричество" hidden={(debtType === "electricity" ? false : true)}>
                        <Input placeholder="" type={"number"} addonAfter={"€ kW\\h"}/>
                    </Form.Item>
                    <Form.Item name="sum" label="Сумма долга">
                        <Input placeholder="" type={"number"} addonAfter={"€"}/>
                    </Form.Item>
                    <Form.Item name="lastPaidMeterData" label="Последние оплаченные показания" hidden={(debtType === "electricity" ? false : true)}>
                        <Input placeholder="" type={"number"} addonAfter={"kW\\h"}/>
                    </Form.Item>
                    <Form.Item name="comment" label="Пояснение">
                        <TextArea placeholder=""/>
                    </Form.Item>
                    <Form.Item name="propertyId" hidden={true}>
                        <Input placeholder="" type={"number"} />
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" style={{marginRight: "10px"}}>Изменить</Button>
                        <Button onClick={handleCancel}>Отмена</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}